import { formatCurrency } from "@/lib/currency/currency";
import { FBT } from "@/lib/i18n/i18n_provider";
import { BookingType, DynamicPriceRate } from "../../data";
import { DynamicPricingAdjustmentType } from "../hooks/use_dynamic_rates_query";

export interface SpaceBulkDiscount {
  minBookingUnit: number;
  saving?: string;
}

export function getSpaceBulkDiscount(
  dynamicPriceRates: DynamicPriceRate[],
  fbt: FBT,
  currency?: string
): SpaceBulkDiscount | undefined {
  let rate: { saving?: string; minBookingUnit: number } | undefined;

  for (const dynamicPriceRate of dynamicPriceRates) {
    const hourlyCriteria = dynamicPriceRate.bookingCriteria.find(
      (bC) => bC.bookingType === BookingType.Hourly
    );
    const { adjustmentType, adjustmentValue } =
      dynamicPriceRate.dynamicPriceFormula;
    if (hourlyCriteria?.minBookingUnit) {
      if (!rate || hourlyCriteria.minBookingUnit < rate.minBookingUnit) {
        rate = {
          saving:
            adjustmentType === DynamicPricingAdjustmentType.Percentage
              ? `${Math.abs(adjustmentValue)}%`
              : adjustmentType === DynamicPricingAdjustmentType.Amount &&
                currency
              ? formatCurrency(Math.abs(adjustmentValue), currency) +
                fbt("/hour")
              : undefined,
          minBookingUnit: hourlyCriteria.minBookingUnit,
        };
      }
    }
  }

  return rate;
}
